export default "__VITE_ASSET__akS6G3MW__"